export const PERSONAL_DETAILS_LOADING = "PERSONAL_DETAILS_LOADING";
export const PERSONAL_DETAILS_SUCCESS = "PERSONAL_DETAILS_SUCCESS";
export const PERSONAL_DETAILS_FAILED = "PERSONAL_DETAILS_FAILED";
export const SAVE_PERSONAL_DETAILS_LOADING = "SAVE_PERSONAL_DETAILS_LOADING";
export const SAVE_PERSONAL_DETAILS_SUCCESS = "SAVE_PERSONAL_DETAILS_SUCCESS";
export const SAVE_PERSONAL_DETAILS_FAILED = "SAVE_PERSONAL_DETAILS_FAILED";
export const UPLOAD_FILE_MULTIPART_LOADING = "UPLOAD_FILE_MULTIPART_LOADING";
export const UPLOAD_FILE_MULTIPART_SUCCESS = "UPLOAD_FILE_MULTIPART_SUCCESS";
export const UPLOAD_FILE_MULTIPART_FAILED = "UPLOAD_FILE_MULTIPART_FAILED";
export const VERIFY_EMAIL_LOADING = "VERIFY_EMAIL_LOADING";
export const VERIFY_EMAIL_SUCCESS = "VERIFY_EMAIL_SUCCESS";
export const VERIFY_EMAIL_FAILED = "VERIFY_EMAIL_FAILED";
export const VERIFY_COMPLETED_LOADING = "VERIFY_COMPLETED_LOADING";
export const VERIFY_COMPLETED_SUCCESS = "VERIFY_COMPLETED_SUCCESS";
export const VERIFY_COMPLETED_FAILED = "VERIFY_COMPLETED_FAILED";

